import { ClientType } from '@/api/types/pt_enums'

let resMap = {} as Record<string, string>

function initEnv(env: ImportMetaEnv) {
  const baseUrl = location.origin
  const result = (env || {}) as {
    -readonly [P in keyof ImportMetaEnv]: ImportMetaEnv[P]
  }
  if (!result.PT_API_BASE_URL) {
    result.PT_API_BASE_URL = baseUrl
  }
  if (!result.PT_RES_BASE_URL) {
    result.PT_RES_BASE_URL = baseUrl
  }
  if (!result.PT_WS_BASE_URL) {
    const url = new URL(result.PT_API_BASE_URL)
    if (url.protocol === 'https:') {
      url.protocol = 'wss:'
    } else {
      url.protocol = 'ws:'
    }
    result.PT_WS_BASE_URL = url.toString()
  }
  const prefixes = result.PT_RES_PREFIX.split(',')
  const resUrls = result.PT_RES_BASE_URL.split(',')
  const lastResUrl = resUrls[resUrls.length - 1]
  resMap = prefixes.reduce(
    (map, resPrefix, index) => {
      if (resPrefix) {
        map[resPrefix] = resUrls[index] || lastResUrl!
      }
      return map
    },
    {} as Record<string, string>
  )
  return result
}
function getClientType() {
  const ua = navigator.userAgent
  if (ua.match(/MicroMessenger/i) && !ua.match(/miniProgram/i)) {
    return ClientType.WEIXIN
  } else if (ua.match(/Alipay/i)) {
    return ClientType.ALIPAY
  } else if (ua.match(/Bytedance/i) && !ua.match(/ToutiaoMicroApp/i)) {
    return ClientType.DOUYIN
  } else if (ua.match(/QQ/i) && !ua.match(/QQBrowser/i)) {
    // 排除QQ浏览器
    return ClientType.QQ
  }
  return ClientType.WEB
}
export function getResUrl(resPrefix: string) {
  return resMap[resPrefix]
}

export const env = initEnv(import.meta.env)
export const clientType = getClientType()
export const appType = env.PT_APP_TYPE || 'ADMIN'
